import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS_WITHOUT_METADATA = ['registrationSurveyCompleted'] as const;

export const surveyEvents = getMappedEvents([...EVENTS_WITHOUT_METADATA]);
